import NonEditableBlock from './base/non-editable-block';
import { computed } from '@ember/object';
import { not } from '@ember/object/computed';
import { htmlEscape, ternaryToProperty } from '@intercom/pulse/lib/computed-properties';
import openingTag from './../../lib/computed-properties/ic-block-opening-tag';
import VideoUrlParser from '@intercom/embercom-composer/lib/video-url-parser';
import Em from 'ember';
export default NonEditableBlock.extend({
  type: 'video',
  inputUrl: null,
  isMedia: true,
  isVideo: true,
  provider: null,
  videoID: null,
  isValid: null,
  escapedVideoID: htmlEscape('videoID'),
  isLinkOnlyMode: not('config.allowVideo'),
  openingTag: openingTag('provider', 'id', 'escapedVideoID', 'isLinkOnlyMode'),
  closingTag: '</ic-block>',
  innerHtml: computed('_zeroWidthSpace', '_paragraphInserter', 'iframeOrLinkHtml', function () {
    return `${this._zeroWidthSpace}${this._paragraphInserter}<span contenteditable="false">${this.iframeOrLinkHtml}</span>${this._paragraphInserter}${this._zeroWidthSpace}`;
  }),
  blockUrl: Em.computed('provider', 'videoID', function (key, value) {
    if (arguments.length > 0) {
      this.set('inputUrl', value);
    }
    return this.get('videoUrl');
  }),
  init() {
    if (this.get('id')) {
      this.set('videoID', this.get('id'));
    }
    this._super();
  },
  parseInputUrl: Em.on('init', Em.observer({
    dependentKeys: ['inputUrl'],
    fn() {
      let inputUrl = this.get('inputUrl');
      if (inputUrl) {
        this.setProperties(VideoUrlParser.parse(inputUrl));
      }
    },
    sync: true
  })),
  videoUrl: Em.computed('provider', 'escapedVideoID', function () {
    let videoID = this.get('escapedVideoID');
    switch (this.get('provider')) {
      case 'youtube':
        return `https://www.youtube.com/embed/${videoID}?rel=0`;
      case 'vimeo':
        return `https://player.vimeo.com/video/${videoID}`;
      case 'wistia':
        return `https://fast.wistia.net/embed/iframe/${videoID}`;
      case 'loom':
        return `https://www.loom.com/embed/${videoID}`;
      case 'vidyard':
        return `https://play.vidyard.com/${videoID}`;
    }
  }),
  iframeOrLinkHtml: ternaryToProperty('isLinkOnlyMode', 'linkHtml', 'iframeHtml'),
  iframeHtml: computed('videoUrl', function () {
    return `<iframe src="${this.videoUrl}" class="video_embed block-iframe" frameborder="0" allowfullscreen=""></iframe>`;
  }),
  linkHtml: computed('videoUrl', function () {
    return `<a class="link-only-mode" href="${this.videoUrl}">View video</a>`;
  }),
  serialized: Em.computed('type', 'provider', 'videoID', function () {
    //TODO: GJ: tests
    return {
      type: this.get('type'),
      provider: this.get('provider'),
      id: this.get('videoID')
    };
  })
});